<template>
  <div id="app" :class="{ 'chat-panel-open': chatPanelOpen }">

    <!-- <app-sideNav v-if="name != 'pageNotFound' && path != '/login' && userRoleSlug != 'super-admin' &&  name != 'resetPassword' && name!='switchClient'"></app-sideNav> -->
    <app-sideNav v-if="sideNavAccess()"></app-sideNav>
    <div :class="{'wrapper':sideNavAccess(),'o-superadmin-wrapper':userRoleSlug == 'super-admin' }" id="page">
      <app-header v-if="headerNavAccess()"></app-header>
      <!-- <app-header v-if="name != 'pageNotFound' && path != '/login' &&  name != 'resetPassword' && name!='switchClient'"></app-header> -->
      <router-view></router-view>
      <vue-progress-bar></vue-progress-bar>
   </div>

    <!-- #2091 — chat UI preview. The component renders NOTHING unless the build
         set CHAT_UI_PREVIEW, so in a normal build this is an empty mount. It is
         outside the page wrapper because the panel is fixed to the viewport, and
         after <router-view> so it sits above page content. Fake data only; it
         calls no service. -->
    <chat-panel v-if="chatUiPreview && name !== 'chatWindow'" @panel-open="chatPanelOpen = $event"></chat-panel>
  </div>
</template>

<script>
    import service from './services'; 
    import HeaderNav from './components/headerNav';
    import ChatPanel from './components/chat/chatPanel';          // #2091, preview only
    import { chatUiEnabled } from './chatPreview.js';
    import SideNav from './components/sideNav';
    import store from './store/store';
    import {publicRoutes} from './routes.js';
    import dateTimeConvert from './timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';

    import { initializeProactiveRefresh, clearRefreshTimer } from './api.js';
    import { registerFcmToken, setupForegroundMessageHandler, getNotificationPermissionState } from './utils/firebase-messaging';

    export default {
        computed: {
            // #2091 — read once; a build either has the preview or it does not.
            chatUiPreview: () => chatUiEnabled(),
            ...mapGetters({
                userRoleSlug: 'userRoleSlug',
                userRole: 'userRole',
                getBrowserSettingsLanguage: 'getBrowserSettingsLanguage',
                userLanguage: 'userLanguage',
                getTokenExpiry: 'getTokenExpiry',
                userToken: 'userToken',
                userToken2: 'userToken2'
            }),
            deviceDetector() {
                let userAgent = navigator.userAgent.toLowerCase();
                const check =(/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) ? "tablet" : /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(userAgent) ? "phone" : "desktop");

                return("desktop" != check ? !0 : !1);
            },
        },

        name: 'App',
        components: {
            'app-header': HeaderNav,
            'app-sideNav': SideNav,
            'chat-panel': ChatPanel,   // #2091, preview only
        },
        watch: {
            '$route' (to, from) {
                this.path = to.path;
                this.name = to.name;
            },
            // REMOVED: getTokenExpiry watcher - was causing race conditions with interceptors
        },
        data() {
            return {
                // #2091 r2 — true while the chat panel is open, so the layout can
                // make room for it. Always false when the preview flag is off.
                chatPanelOpen: false,
                path: this.$route.path,
                name: this.$route.name,
                loginHide: true,
                batchPollTimer: null,
                pageTitle: 'Call Steward',
                metaDescription: 'We create and maintain a set of online tools that allow dispatchers and stagehands to communicate quickly and efficiently about the availability of work.',
                metaKeywords: ['IATSE', 'Stagehand', 'Dispatch', 'Grip', 'Teamsters'],
                canonicalUrl: 'https://www.callsteward.com/',
                organizationData: {
                    name: 'CallSteward',
                    url: 'https://www.callsteward.com/',
                    description: 'We create and maintain a set of online tools that allow dispatchers and stagehands to communicate quickly and efficiently about the availability of work.',
                    sameAs: [
                        'https://www.facebook.com/callsteward',
                        'https://x.com/callsteward'
                    ]
                }
                // REMOVED: refreshInterval, refreshTimeout - interceptors handle all token refresh now
            }
        },
        beforeMount() {},

        async mounted() {
            this.setMetaTags();
            this.setStructuredData();

            if ($('.wrapper').find('.resetPassword').length) {
                $('.wrapper').css('margin-left', '0px');
            }
            if ($('.wrapper').find('.pageNotFound').length) {
                // $('.wrapper').css('margin-left', '0px');
            }

            // Re-register FCM token and foreground handler for returning logged-in users
            if (this.isLoggedIn() && this.userToken && getNotificationPermissionState() === 'granted') {
                registerFcmToken(this.userToken, '').catch(function (e) { console.error('[FCM] mount register error:', e); });
                setupForegroundMessageHandler(this);
            }

            // Poll for completed notify batches (session-level toast)
            this.startBatchPoll();
        },
        
        async created() {
            let current_date_time = moment.utc().format('YYYY-MM-DD HH:mm:ss');
            
            // Keep initial token expiry check on app startup - this is fine
            if ((this.getTokenExpiry!='')&&(!(moment(current_date_time).isBefore(this.getTokenExpiry)))) {
                this.$cookies.remove("csLogin", "/mobile");
                this.$cookies.remove("csLogin");
                this.$cookies.remove("date_format");
                this.$cookies.remove("time_format");
                this.$cookies.remove("time_zone");
                localStorage.removeItem('vuex');
                localStorage.clear();
                this.$store.dispatch('setTokenExpiry', '');
                this.$notify.error({
                    message: 'Your Authorization has expired.Please login again',
                    title: 'Authorization has expired'
                });
                await this.$router.push({
                    name: 'LoginPage',
                    path: '/login'
                })
            }

            if(this.userLanguage && this.userLanguage != '')
                localStorage.setItem("lang", this.userLanguage);
            else {
                let lang = localStorage.getItem("lang")
                if(lang && lang != '' && (typeof lang == 'string'))
                    localStorage.setItem("lang", lang);
                else localStorage.setItem("lang", 'en');
            }
            this.$store.dispatch('saveBrowserSettingsLanguage', localStorage.getItem("lang"));

            const isMobile = this.deviceDetector;
            if(isMobile && window.location.hostname !='localhost'){
                if((this.isLoggedIn()) && (!this.userRole || this.userRole == 'employee')) {
                    // window.location.href = window.location.href.split('#')[0]+"#/mobile/";
                }else if(!this.isLoggedIn()) {
                    let secondPath = window.location.href.split('#')[1];
                    if((secondPath != '/login') || secondPath != '/' || secondPath != '' ) {
                    }else {
                        // window.location.href = window.location.href.split('#')[0]+"#/mobile/login";
                    }
                }
            }else{
                this.loginHide = true;
            }

            if(this.userToken2 && this.userToken2 != '') {
                initializeProactiveRefresh();
            }
        },
        
        beforeDestroy() {
            if (this.batchPollTimer) clearInterval(this.batchPollTimer);
        },
        
        methods: {
            sideNavAccess(){
                // #2091 r4 — the undocked chat is its own window: no side nav,
                // no header, no page wrapper. Excluded by name the same way
                // switchClient is, rather than by adding it to publicRoutes,
                // which would also drop its auth.
                if(publicRoutes.indexOf(this.name) ==-1 && this.name!='switchClient' && this.name!='chatWindow' && this.userRoleSlug != 'super-admin'){
                    return true;
                }
                return false;
            },
            headerNavAccess(){
                if(publicRoutes.indexOf(this.name) ==-1 && this.name!='switchClient' && this.name!='chatWindow'){
                    return true;
                }
                return false;
            },
            isLoggedIn(){
                var user = dateTimeConvert.getCookie('csLogin');
                if(user === "")
                    return false;
                else
                    return true;
            },
            startBatchPoll() {
                if (this.batchPollTimer) clearInterval(this.batchPollTimer);
                this.batchPollTimer = setInterval(() => {
                    this.checkPendingBatches();
                }, 15000);
            },
            checkPendingBatches() {
                if (!this.isLoggedIn() || !this.userToken) return;
                if (!this.$store.getters.hasPendingBatch) return;
                service.get('notify-batches/pending', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.$store.getters.userRole,
                    'cs3-context-clientId': this.$store.getters.userClientID
                }).then((res) => {
                    var batches = (res.data && res.data.result && res.data.result.data) ? res.data.result.data : [];
                    for (var i = 0; i < batches.length; i++) {
                        var b = batches[i];
                        var msg = 'Notifications complete: ' + b.sent + ' sent';
                        if (b.failed > 0) msg += ', ' + b.failed + ' failed';
                        this.$notify({
                            title: b.failed > 0 ? 'Batch Complete (with errors)' : 'Batch Complete',
                            message: msg,
                            type: b.failed > 0 ? 'warning' : 'success',
                            duration: 10000
                        });
                        // Acknowledge so it doesn't show again
                        service.post('notify-batches/' + b.id + '/acknowledge', {}, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.$store.getters.userRole,
                            'cs3-context-clientId': this.$store.getters.userClientID
                        }).catch(function() {});
                    }
                    if (batches.length === 0) {
                        // No pending batches — stop polling until next send
                        this.$store.dispatch('setHasPendingBatch', false);
                    }
                }).catch(function() {});
            },
            setMetaTags() {
                document.title = this.pageTitle;
                document.querySelector('meta[name="description"]').setAttribute('content', this.metaDescription);
                document.querySelector('meta[name="keywords"]').setAttribute('content', this.metaKeywords.join(', '));
                document.querySelector('link[rel="canonical"]').setAttribute('href', this.canonicalUrl);
            },
            setStructuredData() {
                const script = document.createElement('script');
                script.type = 'application/ld+json';
                script.text = JSON.stringify(this.organizationData);
                document.head.appendChild(script);
            }
            // REMOVED: checkTokenStatusOnLoad() and getTokenRefresh() methods
            // These were conflicting with api.js interceptors causing random logouts
        },
        store
    }
</script>

<style>
    .err-msg {
        color: red
    }

    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        position: relative;
    }

    /* #1490 / #1491: clear the fixed .o-header for dispatcher form factors.
       Lives here (App.vue global style) because static/assets/sass/style.scss
       is not wired into webpack — only Vue SFC <style> blocks reach the
       compiled bundle. Phones (<768px) are out of scope per epic #1490. */
    @media (min-width: 768px) {
        .wrapper {
            padding-top: 60px;
        }
    }
    /* Tablet portrait: Bootstrap col-md-* stacks under 992px and .o-header
       reflows ~2x taller, so 60px under-clears. */
    @media (min-width: 768px) and (max-width: 999px) {
        .wrapper {
            padding-top: 120px;
        }
    }

    /* ── #2091 r2 — make room when the chat panel opens ────────────────────────
       Ed on stage-, 1920x1080: "when the chat box opens on the right, collapse
       the Main Menue Left, shift the middle section to the left, look for some
       space, thescreen is only 1080 p".

       The left menu has no wide/narrow state to collapse INTO — `.o-sidenav` is
       a fixed 60px icon rail and the app has no toggle for it — so "collapse"
       here means slide it out of the way, and give the middle both the 60px it
       leaves and clearance from the 368px panel.

       At 1920 that is 1920 - 368 = 1552px of usable width instead of 1492px
       underneath an overlapping panel. The panel is `position: fixed`, so
       without the margin the right-hand ~368px of every table sat UNDER it.

       ⚠ These rules hang off `#app.chat-panel-open`, which only ever appears
       when the preview flag built the panel in AND the user opened it. Flag off
       -> the class can never be set -> not one of these rules can match, which
       is why this is safe to ship dark.

       The transitions are the app's own (`.o-sidenav` 0.5s, `.wrapper`
       margin-left 0.5s, `.o-header` width 0.6s), so the motion matches the rest
       of the UI rather than introducing a new feel. */
    #app.chat-panel-open .o-sidenav {
        transform: translateX(-100%);
        visibility: hidden;
    }

    #app.chat-panel-open .wrapper {
        margin-left: 0;
        margin-right: 368px;
    }

    /* The header is fixed and full-width, so it would run under the panel too. */
    #app.chat-panel-open .o-header {
        width: calc(100% - 368px) !important;
        right: 368px;
    }

    /* The sidebar trigger sits at left:75px, beside a rail that is now gone. */
    #app.chat-panel-open .o-sidebar-trigger {
        transform: translateX(-100%);
        visibility: hidden;
    }

    /* Content inside the wrapper is sized in PERCENTAGES (.c-responsive-fixwidth
       is 85-89% at >=1366px), so it reflows into the new width on its own — the
       middle genuinely shifts left rather than being clipped.

       Below 1366px there is not enough room to do both: 1366 - 368 = 998px, and
       the dispatcher tables need more than that. The panel becomes an overlay
       again there, which is what it already did before this change. */
    @media (max-width: 1365px) {
        #app.chat-panel-open .wrapper {
            margin-left: 0;
            margin-right: 0;
        }
        #app.chat-panel-open .o-header {
            width: 100% !important;
            right: 0;
        }
    }
</style>